import { stylesheet } from 'astroturf';
import clsx from 'clsx';
import { FunctionalComponent } from 'preact';

const styles = stylesheet`
  @import '##/styles/import.scss';

  .shelf-title {
    font-family: barlow;
    & > div {
      display: inline;
    }
  }
`;

interface ShelfTitleProps {
  title: string;
  className?: string;
}

export const ShelfTitle: FunctionalComponent<ShelfTitleProps> = ({
  title,
  className,
  children,
}) => (
  <div className={clsx('tv-h3', styles.shelfTitle, className)}>
    <div>{title}</div>
    {children}
  </div>
);
